import styled from "styled-components/macro";

export const StyledRecommendationContainer = styled.div`
    background: #ffffff;
    width: ${props => props.theme === 'full' ? "100%" : "calc(100% - 54px)"};
    margin: ${props => props.theme === 'full' ? "4rem 0 0 0" : "0 auto"};
    height: 220px;
    border-radius: 4px;
    padding: ${props => props.theme === 'full' ? "2rem" : "1rem"};
    display: flex;
    flex-direction: column;
    position: relative;
`;

export const StyledMarkContainer =styled.div`
    position: absolute;
    width: 38px;
    height: 38px;
    left: ${props => props.theme === 'full' ? "15px" : "10px"};
    top: -19px;
    background: #ffffff;
    border-radius: 50%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top:6px;
`;

export const StyledRecommendee = styled.div`
    display:flex;
    gap: 1rem;
    align-items: center;
    text-align: left;
    margin-top:auto;
    justify-content: ${props => props.theme === 'full' ? "flex-end" : "initial"};
`;

export const StyledRecommendation = styled.div`
    font-weight: 400;
    font-size: 1.2rem;
    font-style: italic;
    line-height:26px;
    width: 85%;
    margin-right: auto;
    text-align: left;
`;